module.exports = __webpack_public_path__ + "static/img/bwguan2.42353d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bwguan2.png
// module id = zQam
// module chunks = 29